webpackJsonp([23],{

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da971254",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "HtmlHintsModal",
  props: ['htmlCode', 'isHtmlEdit', 'htmlKeysListFiltered'],
  data: function data() {
    return {
      listItems: [],
      formData: {
        name: '',
        value: ''
      },
      logoPreview: '',
      err: ''
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    getFormData: function getFormData(files) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          resolve(null);
        };
      });
    },
    onFileChange: function onFileChange($event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var files, data, img;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = $event.target.files || $event.dataTransfer.files;

                if (!(files && files[0])) {
                  _context.next = 17;
                  break;
                }

                _context.next = 4;
                return _this2.getFormData(files);

              case 4:
                data = _context.sent;

                if (!(data === null)) {
                  _context.next = 8;
                  break;
                }

                _this2.err = 'Failed to convert image';
                return _context.abrupt('return');

              case 8:
                if (!(files[0].size > 512000)) {
                  _context.next = 12;
                  break;
                }

                _this2.err = 'The selected images is beyond limit of 512 KB.';
                // this.$set(this.formData, 'name', '');
                _this2.$set(_this2.formData, 'value', '');
                return _context.abrupt('return');

              case 12:
                img = new Image();

                img.src = window.URL.createObjectURL(files[0]);
                img.onload = function () {
                  var width = img.naturalWidth;
                  var height = img.naturalHeight;
                  window.URL.revokeObjectURL(img.src);
                  if (width > 800 || height > 600) {
                    _this2.err = 'The maximum allowed resolution is 800 x 600.';
                    // this.$set(this.formData, 'name', '');
                    _this2.$set(_this2.formData, 'value', '');
                    return;
                  }
                  // this.$set(this.formData, 'name', files[0].name);
                  _this2.$set(_this2.formData, 'value', data);
                  _this2.logoPreview = data;
                };
                _context.next = 18;
                break;

              case 17:
                // this.$set(this.formData, 'name', '');
                _this2.$set(_this2.formData, 'value', '');

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    startInput: function startInput() {
      this.$refs.logoInput.click();
    },
    submitHtmlCode: function submitHtmlCode() {
      if (this.formData.name === '') {
        this.err = 'You must select Position/Name!';
        return;
      }
      if (this.formData.value === '') {
        this.err = 'Value cannot be empty!';
        return;
      }
      this.$emit('submit', this.formData);
    }
  },
  created: function created() {
    this.listItems = this.htmlKeysListFiltered.sort();
    if (this.htmlCode) {
      this.formData = this.htmlCode;
      this.listItems = [this.htmlCode.name].sort();
      if (this.htmlCode.name === 'webshop.logo' && this.htmlCode.value) this.logoPreview = this.htmlCode.value;
    }
  }
});

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"HtmlHintsModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("6a44351b", content, true, {});

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.isHtmlEdit ? 'Edit Html Hint' : 'Add Html Hint'))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Position/Name",
      "items": _vm.listItems,
      "hide-details": ""
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), (_vm.formData.name !== 'webshop.logo' && _vm.formData.name !== 'webshop.headerImage.mobile') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "py-2": ""
    }
  }, [_c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "border": "1px solid #757575",
      "border-radius": "4px"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Html Code"
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  })], 1)]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "p-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoPreview,
      "contain": "",
      "max-height": "200",
      "max-width": "389"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    ref: "logoField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": _vm.$lang.labels.upload
    },
    on: {
      "click": function($event) {
        return _vm.startInput()
      }
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('input', {
    ref: "logoInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitHtmlCode()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.d5f0e72e14687dd06553.js